"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textTableCellRenderer = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const types_1 = require("../types");
function textTableCellRenderer() {
    return (columnProps, rowData, rowHeight) => {
        return (react_1.default.createElement(components_1.Text, { truncate: rowHeight !== types_1.TABLE_ROW_HEIGHT.auto, size: components_1.TEXT_SIZE.m, view: components_1.TEXT_VIEW.primary }, rowData[columnProps.field]));
    };
}
exports.textTableCellRenderer = textTableCellRenderer;
//# sourceMappingURL=textTableCellRenderer.js.map